<template>
  <div class="my-family">
    <van-nav-bar
        title="添加出行人"
        right-text="添加"
        left-arrow
        @click-left="onClickLeft"
        @click-right="onClickRight"
    />
    <div class="body">
      <van-checkbox-group v-model="checked">
        <div class="card" v-for="(user, index) in userList">
          <van-checkbox :name="user.familyId" checked-color="#FF931F">
            <div class="left" style="display: inline-block">
              <div class="name">{{user.familyName}}</div>
              <div class="id-card">{{user.familyIdCard}}</div>
            </div>
            <img src="./img/edit.png" @click.stop="editUser(user)">
          </van-checkbox>

        </div>
      </van-checkbox-group>
    </div>
    <div class="footer">
      <van-button block color="#ff931f" round style="width: 80%;position: fixed;bottom: 0; left: 10%;font-size: 16px" @click="confirmInfo">确定</van-button>
    </div>
  </div>
</template>

<script>
import apiUtil from "../../apiUtil";
import {Toast} from "vant";

export default {
  name: "myFamily",
  data() {
    return {
      checked: [],
      userList: [],
    }
  },
  created() {
    this.getFamilyUser();
    this.initChecked();
  },
  methods: {
    onClickLeft() {
      this.$router.back();
    },
    onClickRight() {
      this.$router.push({
        name: 'AddPeopleInfo'
      })
    },
    async getFamilyUser() {
      let res = await apiUtil.apiUtilGetUrl('/PKECUser/user/get_user_family');
      if (res.errorCode === 0) {
        this.userList = res.pkecUserFamily;
      } else {
        Toast.fail(res.errorMessage);
      }
    },
    toggle(index) {
      this.$refs.checkboxes[index].toggle();
    },
    editUser(user) {
      sessionStorage.setItem('updateUserInfo', JSON.stringify(user));
      this.$router.push({
        name: 'UpdatePeopleInfo'
      })
    },
    initChecked() {
      if (JSON.parse(sessionStorage.getItem('familyUsers'))) {
        let checked = JSON.parse(sessionStorage.getItem('familyUsers'));
        this.checked = checked.map(value => {
          return value.familyId;
        })
      }
    },
    confirmInfo() {
      let familyUsers = [];
      for (let user of this.userList) {
        if (this.checked.indexOf(user.familyId) !== -1) {
          familyUsers.push(user);
        }
      }
      sessionStorage.setItem('familyUsers', JSON.stringify(familyUsers));
      sessionStorage.setItem('checked', JSON.stringify(this.checked));
      this.$router.back();
    }
  }
}
</script>

<style scoped lang="scss">
:deep(.van-nav-bar__text) {
  color: #222222 !important;
}
:deep(.van-nav-bar .van-icon) {
  color: #222222 !important;
}
img {
  -webkit-touch-callout: none;
  //pointer-events: none;
}

.body {
  .card {
    position: relative;
    margin: 9px 12px 0;
    background-color: #fff;
    padding: 15px 18px 15px 12px;
    border-radius: 8px;
    overflow: hidden;
    .name {
      color: #222222;
      font-size: 18px;
      margin-left: 12px;
    }
    .id-card {
      margin-top: 10px;
      margin-left: 12px;
      color: #828282;
      font-size: 16px;
    }
    img {
      position: absolute;
      right: 30px;
      top: 30px;
      width: 16px;
      height: 18px;
    }
    :deep(.van-checkbox__icon .van-icon) {
      border: 1px solid #ff931f;
    }
  }
}

</style>